import { BLOG_POSTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/blog_posts_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['emptorBlogPosts']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
